import { type ReactElement } from 'react'
import {
  // reason: this is the wrapped component which we will allow since this is the exported version
  // eslint-disable-next-line @dhl/dhl-ui/no-restricted-imports
  Tooltip as MuiTooltip,
  type TooltipProps as MuiTooltipProps,
} from '@mui/material'
import { Ellipsis } from '../Ellipsis'

export type TooltipProps = Pick<MuiTooltipProps, 'children' | 'open' | 'onOpen' | 'onClose' | 'followCursor'> & {
  /**
   * The actual tooltip text, for example we assume `t('common.foo')` or `<Trans .../>` or something with a Link
   * we maximize it over 4 lines
   */
  title: string | ReactElement

  /**
   * Placement of the tooltip
   * @default 'bottom'
   */
  placement?: Pick<MuiTooltipProps, 'placement'>['placement'] & ('top' | 'bottom' | 'left' | 'right')
}

/**
 * Tooltip
 *
 * Demos:
 * - [Tooltip](https://design-system.accept.cl1.intra.dhlparcel.io/?path=/docs/primitives-tooltip--docs)
 *
 */

export const Tooltip = ({ children, title, ...rest }: TooltipProps) => (
  <MuiTooltip
    title={
      <Ellipsis lineClamp={4} variant="body2">
        {title}
      </Ellipsis>
    }
    {...rest}
    arrow
  >
    {children}
  </MuiTooltip>
)
